export const namespaced = true;

export const state = {
    activeElement: null, // el из order
    movingUuids: [],
    rotatingUuids: [],
}

export const mutations = {

    SET_ACTIVE(state, el) {
        state.activeElement = el;
    },

    CLEAR_ACTIVE(state) {
        state.activeElement = null;
    },

    ADD_MOVING_UUID(state, uuid) {
        state.movingUuids.push(uuid);
    },
    REMOVE_MOVING_UUID(state, uuid) {
        state.movingUuids = state.movingUuids.filter(mu => mu != uuid)
    },

    ADD_ROTATING_UUID(state, uuid) {
        state.rotatingUuids.push(uuid);
    },
    REMOVE_ROTATING_UUID(state, uuid) {
        state.rotatingUuids = state.rotatingUuids.filter(mu => mu != uuid)
    },
}

export const actions = {

    setActive({ commit }, el) {
        commit('SET_ACTIVE', el);
    },

    clearActive({ commit }) {
        commit('CLEAR_ACTIVE');
    },

    addMovingUuid({ commit }, uuid) {
        commit('ADD_MOVING_UUID', uuid);
    },
    removeMovingUuid({ commit }, uuid) {
        commit('REMOVE_MOVING_UUID', uuid);
    },
    addRotatingObject({ commit }, uuid) {
        commit('ADD_ROTATING_UUID', uuid);
    },
    removeRotatingObject({ commit }, uuid) {
        commit('REMOVE_ROTATING_UUID', uuid);
    }
}
